module.exports = __webpack_public_path__ + "static/Prof.AzisNatherPhDSIN-a0ee320632dff3dc78a71a0fd0f99cb8.jpg";